module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企订单-明细编辑"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.detailData.trans_bill_no) + "\n\t\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "state-aqua-font"
  }, [_vm._v("待发货")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billInfoShow),
      expression: "billInfoShow"
    }],
    staticClass: "bill-all-info"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("订货企业：" + _vm._s(_vm.detailData.restaurant_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t\t订货机构/时间：" + _vm._s(_vm.detailData.from_organ_name) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm._f("dateFilterYMD")(_vm.detailData.from_date)))])]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("\n\t\t\t\t\t\t收货机构/时间：" + _vm._s(_vm.detailData.to_organ_name) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm._f("dateFilterYMD")(_vm.detailData.to_date)))])]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("整单备注：" + _vm._s(_vm.detailData.remark))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("\n\t\t\t\t\t\t发货描述：\n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailData.delivery_describe),
      expression: "detailData.delivery_describe"
    }],
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.detailData.delivery_describe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailData, "delivery_describe", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("\n\t\t\t\t\t\t快递服务商：\n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailData.express_provider),
      expression: "detailData.express_provider"
    }],
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.detailData.express_provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailData, "express_provider", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("\n\t\t\t\t\t\t快递单号：\n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailData.express_no),
      expression: "detailData.express_no"
    }],
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.detailData.express_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailData, "express_no", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "detail-search-input",
    attrs: {
      "placeholder": "请输入要搜索的品项名称"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [_c('h4', {
    staticClass: "detail-bill-address aqua-font"
  }, [_vm._m(0), _vm._v("\n\t\t\t\t\t明细条目(" + _vm._s(_vm.detailsFilter.length) + ")\n\t\t\t\t\t"), _c('a', {
    staticClass: "detail-bill-edit state-aqua-font",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list"
  }, _vm._l((_vm.detailsFilter), function(detail, index) {
    return _c('li', [_c('ul', {
      staticClass: "detail-bill-sonlist"
    }, [_c('li', {
      staticClass: "detail-bill-fulllist detail-bill-list-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(detail.goods_name)), ((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? _c('span', [_vm._v("(" + _vm._s(detail.goods_unit) + ")")]) : _vm._e(), _vm._v(" " + _vm._s(detail.gift_flag ? '【赠品】' : '') + "\n\t\t\t\t\t\t\t\t"), (_vm.detailData.billBusTypeID !== '0450_0030_0600_3') ? _c('span', {
      staticClass: "fr silvery-font"
    }, [_vm._v(_vm._s(detail.inStoreName))]) : _c('span', {
      staticClass: "fr silvery-font"
    }, [_vm._v(_vm._s(detail.inStoreName) + "/" + _vm._s(detail.shopStoreName))])]), _vm._v(" "), ((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? _c('li', [_vm._v("订货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num, _vm.numScale)))]) : _vm._e(), _vm._v(" "), (detail.bill_gross_weight) ? _c('li', [_vm._v("毛重：" + _vm._s(_vm._f("numFixed")(detail.bill_gross_weight, 4)))]) : _vm._e(), _vm._v(" "), ((detail.goods_assist_unit ? _vm.showAssistUnitFlag : true) || _vm.isZ5) ? _c('li', [_vm._v("发货数量：\n\t\t\t\t\t\t\t\t"), (_vm.detailData.can_change_cnt) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_num_send),
        expression: "detail.goods_num_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.goods_num_send)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_num_send", $event.target.value)
        }, function($event) {
          return _vm.goodsNumCount(detail)
        }],
        "blur": function($event) {
          return _vm.goodsNumCountFixed(detail)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_num_send),
        expression: "detail.goods_num_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_num_send)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_num_send", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.detailData.partial_delivery_flag === 1) ? _c('li', [_vm._v("已发数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_sended, _vm.numScale)))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailData.hiddenTax),
        expression: "!detailData.hiddenTax"
      }]
    }, [_vm._v("含税")]), _vm._v("单价：\n\t\t\t\t\t\t\t\t"), (_vm.detailData.can_change_price && !detail.gift_flag) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_price_send),
        expression: "detail.goods_price_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.goods_price_send)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_price_send", $event.target.value)
        }, function($event) {
          return _vm.sendPriceCount(detail)
        }],
        "blur": function($event) {
          return _vm.sendPriceCountFixed(detail)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_price_send),
        expression: "detail.goods_price_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_price_send)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_price_send", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.detailData.partial_delivery_flag === 1) ? _c('li', [_vm._v("待发数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_wait_send, _vm.numScale)))]) : _vm._e(), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailData.hiddenTax),
        expression: "!detailData.hiddenTax"
      }]
    }, [_vm._v("价税合计：\n\t\t\t\t\t\t\t\t"), (_vm.detailData.can_change_price && !detail.gift_flag) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.sub_total_send),
        expression: "detail.sub_total_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.sub_total_send)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "sub_total_send", $event.target.value)
        }, function($event) {
          return _vm.subSendCount(detail)
        }],
        "blur": function($event) {
          return _vm.subSendCountFixed(detail)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.sub_total_send),
        expression: "detail.sub_total_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.sub_total_send)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "sub_total_send", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailData.hiddenTax),
        expression: "!detailData.hiddenTax"
      }]
    }, [_vm._v("税率\n\t\t\t\t\t\t\t\t"), (_vm.detailData.can_change_price && !detail.gift_flag && _vm.detailData.canChangeTaxes) ? _c('span', {
      staticStyle: {
        "position": "relative",
        "left": "-10px"
      }
    }, [_c('span', {
      staticClass: "tax-operate tax-operate-reduce",
      on: {
        "click": function($event) {
          return _vm.reduce(detail)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_cess),
        expression: "detail.goods_cess"
      }],
      staticClass: "detail-bill-edit-taxinput",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (detail.goods_cess)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_cess", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "detail-bill-edit-percent"
    }), _vm._v(" "), _c('span', {
      staticClass: "tax-operate tax-operate-plus",
      on: {
        "click": function($event) {
          return _vm.plus(detail)
        }
      }
    })]) : _c('span', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_cess),
        expression: "detail.goods_cess"
      }],
      staticClass: "detail-bill-edit-taxinput",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (detail.goods_cess)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_cess", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (detail.goods_assist_unit != null),
        expression: "detail.goods_assist_unit!=null"
      }]
    }, [_c('li', [_c('div', {
      staticStyle: {
        "height": "30px",
        "line-height": "30px"
      }
    }, [_vm._v("辅助单位：" + _vm._s(detail.goods_assist_unit))])]), _vm._v(" "), _c('li', [_vm._v("订货辅助数量：\n\t\t\t\t\t\t\t\t\t"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_assist_num),
        expression: "detail.goods_assist_num"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_assist_num)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_assist_num", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('li', [_vm._v("发货辅助数量：\n\t\t\t\t\t\t\t\t\t"), (_vm.assistUnitHandleFlag) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_assist_num_send),
        expression: "detail.goods_assist_num_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.goods_assist_num_send)
      },
      on: {
        "blur": function($event) {
          return _vm.goodsAssistCountFixed(detail)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_assist_num_send", $event.target.value)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_assist_num_send),
        expression: "detail.goods_assist_num_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_assist_num_send)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_assist_num_send", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('li', [_vm._v("实收辅助数量：\n\t\t\t\t\t\t\t\t\t"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_assist_num_recipient),
        expression: "detail.goods_assist_num_recipient"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_assist_num_recipient)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_assist_num_recipient", $event.target.value)
        }
      }
    })])]), _vm._v(" "), (!(detail.remark == null || detail.remark == '')) ? _c('li', {
      staticClass: "detail-bill-fulllist"
    }, [_vm._v("备注：" + _vm._s(detail.remark))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (!_vm.detailsFilter.length) ? _c('div', {
    staticClass: "detail-bill-search-empty"
  }, [_c('div', {
    staticClass: "middle-empty"
  }), _vm._v(" "), _c('p', [_vm._v("未找到相关品项")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "detail-else-info"
  }, [_c('p', [_vm._v("配送至：" + _vm._s(_vm.detailData.to_organ_name))]), _vm._v(" "), _c('p', {
    staticClass: "detail-else-info-list"
  }, [_c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货金额：" + _vm._s(_vm._f("numFixed")(_vm.detailData.sum_money, _vm.numScale)) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsNum, _vm.numScale)))])]), _vm._v(" "), _c('p', {
    staticClass: "detail-else-info-list"
  }, [(!_vm.isZ5) ? _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("订货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNum, _vm.numScale)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "detail-else-info-list"
  }, [(!_vm.isZ5) ? _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("发货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumSend, _vm.numScale)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "detail-else-info-list"
  }, [(!_vm.isZ5) ? _c('span', {
    staticClass: "detail-else-info-list-span"
  }, [_vm._v("收货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumRecipient, _vm.numScale)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-info"
  }, [_c('span', {
    staticClass: "detail-bill-total-btn",
    on: {
      "click": _vm.infoExchange
    }
  }, [_vm._v("合计")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-agreen f-right"
  }, [_c('a', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])]), _vm._v(" "), (_vm.detailData.bill_state == 11) ? _c('div', {
    staticClass: "detail-bill-return f-right",
    class: {
      'bgGrey': ((_vm.uploadImgList.length === 0 && _vm.uploadDeliverFlag) || (_vm.expressNoDeliveryFlag && _vm.detailData.express_no === ''))
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.askSend(false)
      }
    }
  }, [_vm._v("发货")])]) : _vm._e(), _vm._v(" "), (_vm.detailData.partial_delivery_flag === 1) ? _c('div', {
    staticClass: "detail-bill-retrun-bgOrange f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.askSend(true)
      }
    }
  }, [_vm._v("分批发货")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsTwoShow),
      expression: "tipsTwoShow"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.tipsTwoShow, 'tips-end': !_vm.tipsTwoShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.elseTipsFont))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveReturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[0]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn tips-marbot",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.quitRuturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[1]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[2]))])])])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFontWaring": _vm.tipsWaring,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "list-btn fl"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/list_open.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2725686!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DetailBillFirstEdit.vue
// module id = 609
// module chunks = 1